export default function TS_Tooling() {
  return (
    <div>
      <h1>TS Tooling</h1>
      <p>This is the TS Tooling page.</p>
    </div>
  );
}